const header = document.getElementById("Header");
const mobileNavigation = document.querySelector(".nav.mobile");

if (header && mobileNavigation) {
    const burgerMenu = header.querySelector("#BurgerMenu");

    if (burgerMenu) {
        burgerMenu.addEventListener("click", () => {
            const active = burgerMenu.classList.toggle("open");
            mobileNavigation.classList.toggle("open", active);
        });
    }
}
